import React, {useEffect, useState} from 'react';
import {HttpStatus} from "../../../../../modules/common/enums/HttpStatus";
import {RequestVisitorDto} from "../../../../../modules/vms/dto/RequestVisitorDto";
import {FormattedMessage, useIntl} from "react-intl";
import {Card, CardHeader, Table, TableBody, TableCell, TableHead, TableRow} from "@mui/material";
import RefreshIconButton from "../../../../../components/buttons/RefreshIconButton";
import StringUtils from "../../../../../utils/StringUtils";
import {RequestVisitorApi} from "../../../../../modules/vms/api/RequestVisitorApi";
import {VisitorStatus} from "../../../../../modules/vms/enums/VisitorStatus";
import RequestVisitorDetailDialog from "../../../components/RequestVisitorDetailDialog";

const Index: React.FC = () => {

    const intl = useIntl();

    const [visitRequestList, setVisitRequestList] = useState<Array<RequestVisitorDto>>([]);

    const [openDetailModal, setOpenDetailModal] = useState(false);

    const [currentRow, setCurrentRow] = useState<RequestVisitorDto>(new RequestVisitorDto());

    const handleShowDetail = async (record: RequestVisitorDto) => {
        const responseResult = await RequestVisitorApi.getVisitorDetailById(record.id);
        if (responseResult.status === HttpStatus.SUCCESS) {
            setCurrentRow(responseResult.data);
            setOpenDetailModal(true);
        }
    };

    useEffect(() => {
        // 查询用户组列表
        fetchPendingCheckinList();
    }, []);

    const fetchPendingCheckinList = async () => {
        const responseResult = await RequestVisitorApi.getPendingCheckinList();
        if (responseResult.status === HttpStatus.SUCCESS) {
            setVisitRequestList(responseResult.data);
        }
    };

    return (
        <Card>
            <CardHeader
                action={
                    <RefreshIconButton onClick={() => fetchPendingCheckinList()}/>
                }
                title={intl.formatMessage({id: 'VMS_VISIT_REQUEST_PENDING_APPROVAL_LIST'})}
            />
            <RequestVisitorDetailDialog open={openDetailModal}
                                        onClose={() => setOpenDetailModal(false)}
                                        requestVisitor={currentRow}
                                        onApprove={fetchPendingCheckinList}
                                        onReject={fetchPendingCheckinList} canApprove={true}/>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>{intl.formatMessage({id: 'VMS_REQUEST_VISITOR_NAME'})}</TableCell>
                        <TableCell>{intl.formatMessage({id: 'VMS_REQUEST_VISITOR_MOBILE'})}</TableCell>
                        <TableCell>{intl.formatMessage({id: 'VMS_REQUEST_VISITOR_COMPANY'})}</TableCell>
                        <TableCell>{intl.formatMessage({id: 'VMS_REQUEST_VISITOR_ARRIVE_DATE'})}</TableCell>
                        <TableCell>{intl.formatMessage({id: "VMS_REQUEST_VISITOR_STATUS"})}</TableCell>
                        <TableCell>{intl.formatMessage({id: 'COMMON_ACTION'})}</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {visitRequestList.map((row) => (
                        <TableRow key={row.id}>
                            <TableCell>{row.fullName}</TableCell>
                            <TableCell>{row.mobile}</TableCell>
                            <TableCell>{row.company}</TableCell>
                            <TableCell>{StringUtils.formatDate(row.visitRequest?.arriveStartDate) + "~" + StringUtils.formatDate(row.visitRequest?.arriveEndDate)}</TableCell>
                            <TableCell><FormattedMessage id={VisitorStatus.Map.get(row.status)}/></TableCell>
                            <TableCell>
                                <a href={'javascript:void(0)'} onClick={() => handleShowDetail(row)}>
                                    <FormattedMessage id={'COMMON_DETAIL'}/>
                                </a>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </Card>
    );
};

export default Index;
